<div class="main">
  <div class="custom-card">
    <div class="card-content">
      <div class="content">
        <h5 class="mainTitle">Hi!, My Name's Nicolás Alani 👋</h5>
      </div>
      <p>
        Hi! , I'm a software developer from Argentina,
        an innovative tech mind with 3 years of experience in the field of software development.
        Capable of working with a variety of technology and software solution.
        Today I'm focusing on keeping learning weird technology stuff and grow both personally and professionally.
      </p>
    </div>
    <p>
      <strong style="font-size: 20px;">Currently working with this stack...</strong>
    </p>
    <app-technologies></app-technologies>
    <hr>
    <div class="contact">
      <div style="cursor: pointer; text-align: center;">
        <p>Want to know more about me?...</p>
        <span (click)="onSendMail()" class="send-mail">Send Mail 📧</span>
      </div>
    </div>

    <div class="vertical-center" style="margin-top: 50px;">
      <button class="download-button">Download CV</button>
    </div>
  </div>

</div>
